export const suggestedAction = {
  CREATE: 'CREATE',
  DEACTIVATE: 'DEACTIVATE',
  REACTIVATE: 'REACTIVATE',
  GROUP_JOIN: 'GROUP_JOIN',
  GROUP_LEAVE: 'GROUP_LEAVE'
} as const;
export type SuggestedAction = (typeof suggestedAction)[keyof typeof suggestedAction];
type ActionWithDescribe = {
  describe: string;
};
export type AppUserActionPart = {
  type: SuggestedAction;
  disabled: boolean;
  describe?: string;
};
export type CreateAction = {
  type: typeof suggestedAction.CREATE;
  disabled: boolean;
};
export type DeactivateAction = {
  type: typeof suggestedAction.DEACTIVATE;
  disabled: boolean;
} & ActionWithDescribe;
export type ReactivateAction = {
  type: typeof suggestedAction.REACTIVATE;
  disabled: boolean;
};
export type GroupJoinAction = {
  type: typeof suggestedAction.GROUP_JOIN;
  disabled: boolean;
};
export type GroupLeaveAction = {
  type: typeof suggestedAction.GROUP_LEAVE;
  disabled: boolean;
};

//TODO アカウントの権限変更用アクションを作る

export type AppUserAction = CreateAction | DeactivateAction | ReactivateAction | GroupJoinAction | GroupLeaveAction;